/*
  ============================================================================
  Ro Ro — listado de producto
  ----------------------------------------------------------------------------
  Lo mínimo que el motor de Shopify no cubre. Todo lo que ya hace Horizon
  (estado de los filtros, Section Rendering API, limpiar todo, precio) NO se
  reimplementa aquí: ver `snippets/roro-filter-drawer.liquid`.

  Cinco cosas, y ninguna más:

    1. Los tabs son `<a href>` de verdad. Si hay JS, el clic se convierte en un
       repintado por Section Rendering API; si no lo hay, el enlace navega y la
       página se sirve igual. Mejora progresiva, no dependencia.
    2. El botón «Сортування» abre el mismo panel que «Фільтр» y despliega el
       grupo de ordenar.
    2 bis. Llegar con `#rpl-filters` abre el panel al cargar: es lo que hace el
       botón de filtros de `/collections`, que allí es un enlace porque esa
       plantilla no tiene motor de facetas.
    3. Modo diferido: aplicar los filtros solo al pulsar el botón.
    4. Tras un repintado (filtro o scroll infinito), volver a alimentar el
       quick-add con los productos que ahora hay en pantalla.

  Todo delegado en `document`, sin init por nodo: el morph de la Section
  Rendering API sustituye nodos por debajo y un listener por elemento se
  perdería. Mismo criterio que `assets/roro-cart-drawer.js`.
  ============================================================================
*/
(function () {
  'use strict';

  /* --------------------------------------------------------------------------
     1. Tabs de categoría

     Solo los tabs con `data-rpl-tab` se interceptan: son los que filtran la
     colección actual. El salto a la colección hermana (Best Sellers ↔ New
     Arrivals) es otra página, así que navega como cualquier enlace.
     -------------------------------------------------------------------------- */

  /**
   * Marca el tab pulsado como activo sin esperar al repintado.
   *
   * El estado bueno vuelve de Liquid con la Section Rendering API, pero entre
   * el clic y la respuesta hay unos cientos de milisegundos en los que la fila
   * seguiría señalando la categoría anterior. Esto solo adelanta ese cambio.
   */
  function markActive(tab) {
    var nav = tab.closest('[data-rpl-tabs]');
    if (!nav) return;

    nav.querySelectorAll('.rpl-tabs__link').forEach(function (link) {
      var isActive = link === tab;
      link.classList.toggle('rpl-tabs__link--active', isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  /**
   * Deja el tab activo a la vista dentro de su fila con scroll.
   *
   * Se mueve `scrollLeft` de la lista a mano en vez de usar `scrollIntoView`
   * porque este también desplazaría la página en vertical: al entrar filtrado
   * desde una URL, la pantalla saltaría por debajo del título.
   */
  function revealActiveTab(root) {
    root.querySelectorAll('.rpl-tabs__list').forEach(function (list) {
      var active = list.querySelector('.rpl-tabs__link--active');
      if (!active || list.scrollWidth <= list.clientWidth) return;

      var listRect = list.getBoundingClientRect();
      var itemRect = active.getBoundingClientRect();
      list.scrollLeft += itemRect.left - listRect.left - (listRect.width - itemRect.width) / 2;
    });
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-rpl-tab]');
    if (!tab) return;

    // Respetar los gestos de "abrir en pestaña nueva".
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

    var form = document.getElementById(tab.getAttribute('data-rpl-form') || '');
    if (!form || typeof form.updateFiltersByURL !== 'function') return;

    event.preventDefault();
    markActive(tab);
    form.updateFiltersByURL(tab.getAttribute('href'));
  });

  /* --------------------------------------------------------------------------
     2. «Сортування» abre el panel por el grupo de ordenar

     `dialog-component` abre el diálogo en el siguiente frame (lo hace dentro
     de un requestAnimationFrame para que el clic termine de burbujear), así
     que hay que esperar a que exista antes de desplegar el grupo.
     -------------------------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-rpl-open-sort]');
    if (!trigger) return;

    var host = document.getElementById(
      (trigger.getAttribute('on:click') || '').slice(1).split('/')[0]
    );
    if (!host) return;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var group = host.querySelector('[data-rpl-sort-group]');
        if (!group) return;
        group.open = true;
        group.scrollIntoView({ block: 'nearest' });
      });
    });
  });

  /* --------------------------------------------------------------------------
     2 bis. Llegada con #rpl-filters: abrir el panel al cargar

     `/collections` pinta la rejilla del catálogo entero, pero no es una
     plantilla de colección: el motor de facetas de Shopify no existe ahí y el
     panel saldría vacío. Por eso su botón de filtros es un enlace a la página
     real de la colección con este hash — llegar aquí equivale a haberlo
     pulsado, así que el panel se abre solo y el usuario no tiene que buscarlo
     otra vez.

     El hash se borra del historial en cuanto se usa: si no, volver atrás desde
     un producto reabriría el panel sin que nadie lo haya pedido.
     -------------------------------------------------------------------------- */
  function openFiltersFromHash() {
    if (window.location.hash !== '#rpl-filters') return;

    var host = document.querySelector('.rpl-drawer-host');
    if (!host) return;

    // El custom element puede no estar definido todavía: `dialog.js` es un
    // módulo y su `customElements.define` llega después de este archivo.
    customElements.whenDefined('dialog-component').then(function () {
      history.replaceState(null, '', window.location.pathname + window.location.search);
      if (typeof host.showDialog === 'function') host.showDialog();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openFiltersFromHash);
  } else {
    openFiltersFromHash();
  }

  /* --------------------------------------------------------------------------
     3. Modo diferido: aplicar al pulsar
     -------------------------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var apply = event.target.closest('[data-rpl-apply]');
    if (!apply) return;

    var form = document.getElementById(apply.getAttribute('data-rpl-apply') || '');
    if (form && typeof form.updateFilters === 'function') form.updateFilters();

    var host = apply.closest('dialog-component');
    if (host && typeof host.closeDialog === 'function') host.closeDialog();
  });

  /* --------------------------------------------------------------------------
     4. Realimentar el quick-add tras un repintado

     El motor de la tarjeta (`roro-product-carousel.js`) lee
     `[data-na-products]` UNA vez al arrancar y se lo queda en su closure. Al
     filtrar, o al cargar otra página con scroll infinito, las tarjetas del DOM
     cambian pero ese array no, y el «+» de un producto nuevo no encontraría
     sus datos.

     Cada bloque trae su propio `[data-na-products-chunk]`, así que aquí solo
     hay que recomponer el array a partir de lo que hay ahora en pantalla y
     pedirle al motor que lo relea. Se usa `refresh` y NUNCA `init`: `init`
     volvería a registrar los listeners y cada «añadir al carrito» metería dos
     unidades (ver `rules/liquid-patterns.md`).
     -------------------------------------------------------------------------- */
  function collectProducts(root) {
    var out = [];
    var seen = {};

    root.querySelectorAll('[data-na-products-chunk]').forEach(function (node) {
      var parsed;
      try {
        parsed = JSON.parse(node.textContent || '[]');
      } catch (error) {
        return;
      }
      if (!Array.isArray(parsed)) return;

      parsed.forEach(function (item) {
        if (!item || seen[item.id]) return;
        seen[item.id] = true;
        out.push(item);
      });
    });

    return out;
  }

  function syncRoot(root) {
    var target = root.querySelector('[data-na-products]');
    if (!target) return;

    var products = collectProducts(root);

    if (products.length) {
      var next = JSON.stringify(products);
      if (next !== root.__rplLastProducts) {
        root.__rplLastProducts = next;
        target.textContent = next;
      }
    }

    /* Fuera del `if`: hay repintados que devuelven exactamente los mismos
       productos (reordenar, o un filtro que no recorta nada) y aun así morph
       ha rehecho las tarjetas y se ha llevado las capas del slideshow. Si esto
       colgara del diff del JSON, esas tarjetas se quedarían sin arreglar. */
    if (window.RoroProductCarousel && typeof window.RoroProductCarousel.refresh === 'function') {
      window.RoroProductCarousel.refresh(root);
    }
  }

  function watch(root) {
    if (root.__rplWatched) {
      revealActiveTab(root);
      initInfiniteScroll(root);
      return;
    }
    root.__rplWatched = true;

    var pending = null;
    var observer = new MutationObserver(function () {
      if (pending) clearTimeout(pending);
      pending = setTimeout(function () {
        pending = null;
        syncRoot(root);
        revealActiveTab(root);
      }, 120);
    });

    observer.observe(root, { childList: true, subtree: true, characterData: true });
    syncRoot(root);
    revealActiveTab(root);
    initInfiniteScroll(root);
  }

  /* --------------------------------------------------------------------------
     5. Scroll infinito con IntersectionObserver y Section Rendering API
     -------------------------------------------------------------------------- */
  function initInfiniteScroll(root) {
    if (!root) return;

    var isInfinite = root.getAttribute('data-infinite-scroll') === 'true';
    if (!isInfinite) return;

    // Desconectar observer previo si existía (por ejemplo tras re-render de filtro)
    if (root.__rplInfiniteObserver) {
      root.__rplInfiniteObserver.disconnect();
      root.__rplInfiniteObserver = null;
    }

    var grid = root.querySelector('[ref="grid"]');
    var sentinel = root.querySelector('[data-rpl-sentinel]');
    var loader = root.querySelector('[data-rpl-loader]');
    var sectionId = root.getAttribute('data-section-id') || root.getAttribute('section-id');

    if (!grid || !sentinel || !sectionId) return;

    // Cuánto antes del final se pide la página siguiente. Con 400px el lote nuevo
    // llegaba con el texto de la colección y el pie ya en pantalla y los empujaba
    // hacia abajo: CLS de 0,15 a 0,25 en las colecciones largas (medido en el
    // draft el 2026-09-25). Con 1000px entra mientras siguen fuera de pantalla, y
    // al cargar la página el centinela aún queda fuera del margen (móvil y 1440px).
    var PREFETCH_MARGIN = 1000;

    var isLoading = false;

    function getNextPage() {
      var allBlocks = grid.querySelectorAll('.rpl-block');
      if (!allBlocks.length) return null;
      var lastBlock = allBlocks[allBlocks.length - 1];
      var currentPage = parseInt(lastBlock.getAttribute('data-page') || '1', 10);
      var lastPage = parseInt(grid.getAttribute('data-last-page') || '1', 10);
      if (isNaN(currentPage) || isNaN(lastPage) || currentPage >= lastPage) return null;
      return {
        nextPage: currentPage + 1,
        lastPage: lastPage
      };
    }

    async function loadNextBatch() {
      if (isLoading) return;
      var pageInfo = getNextPage();
      if (!pageInfo) {
        if (root.__rplInfiniteObserver) {
          root.__rplInfiniteObserver.disconnect();
          root.__rplInfiniteObserver = null;
        }
        if (loader) loader.style.display = 'none';
        return;
      }

      isLoading = true;
      if (loader) loader.style.display = 'flex';

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('page', pageInfo.nextPage.toString());
        url.searchParams.set('section_id', sectionId);

        var res = await fetch(url.toString(), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (!res.ok) throw new Error('Fetch failed: ' + res.status);

        var htmlText = await res.text();
        var parser = new DOMParser();
        var doc = parser.parseFromString(htmlText, 'text/html');

        var newGrid = doc.querySelector('[ref="grid"]');
        if (newGrid) {
          var newBlocks = Array.from(newGrid.querySelectorAll(':scope > .rpl-block'));
          if (newBlocks.length > 0) {
            newBlocks.forEach(function (block) {
              grid.appendChild(block);
            });

            // La URL NO se toca (2026-09-29). Antes se escribía `?page=N` en cada
            // tanda, y esa URL solo pinta la tanda N: quien volvía atrás desde una
            // ficha sin caché de retroceso (navegador de Instagram, sobre todo) o
            // compartía el enlace veía 16 productos y perdía los 32 primeros, que
            // son los más vendidos. No hay carga de las tandas anteriores.

            // Re-sincronizar productos y swatches
            syncRoot(root);
          }
        }

        // Si ya hemos llegado a la última página, desconectar observer
        if (pageInfo.nextPage >= pageInfo.lastPage) {
          if (root.__rplInfiniteObserver) {
            root.__rplInfiniteObserver.disconnect();
            root.__rplInfiniteObserver = null;
          }
        }
      } catch (err) {
        console.warn('[ro.ro infinite scroll] Error fetching batch:', err);
      } finally {
        isLoading = false;
        if (loader) loader.style.display = 'none';

        // Si la pantalla es muy alta y el centinela sigue visible, pedir el siguiente lote
        if (getNextPage() && root.__rplInfiniteObserver && sentinel) {
          var rect = sentinel.getBoundingClientRect();
          if (rect.top <= window.innerHeight + PREFETCH_MARGIN) {
            loadNextBatch();
          }
        }
      }
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            loadNextBatch();
            break;
          }
        }
      }, {
        root: null,
        rootMargin: PREFETCH_MARGIN + 'px 0px',
        threshold: 0.01
      });

      observer.observe(sentinel);
      root.__rplInfiniteObserver = observer;
    }
  }

  function start(scope) {
    (scope || document).querySelectorAll('.rpl[data-na-root]').forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(document); }, { once: true });
  } else {
    start(document);
  }

  // El theme editor reinyecta la sección entera al cambiar un setting.
  document.addEventListener('shopify:section:load', function (event) { start(event.target); });

  /* --------------------------------------------------------------------------
     5. Texto de la colección (`snippets/roro-listing-about.liquid`)

     Elemento propio y no delegación: el repintado de filtros lo vuelve a
     insertar y `connectedCallback` lo recoge solo. Recorta a dos líneas solo
     si el texto no cabe; si cabe, no hay botón.
     -------------------------------------------------------------------------- */
  if (!customElements.get('rpl-about')) {
    customElements.define('rpl-about', class extends HTMLElement {
      connectedCallback() {
        var text = this.querySelector('[data-rpl-about-text]');
        var toggle = this.querySelector('[data-rpl-about-toggle]');
        if (!text || !toggle || this.dataset.ready) return;
        this.dataset.ready = 'true';

        // Se mide en el siguiente fotograma: al insertarse, el bloque aún no
        // tiene su ancho final y un texto corto podría parecer largo.
        var self = this;
        requestAnimationFrame(function () {
          self.classList.add('is-clamped');
          if (text.scrollHeight <= text.clientHeight + 1) {
            self.classList.remove('is-clamped');
            return;
          }
          toggle.hidden = false;
        });

        toggle.addEventListener('click', function () {
          var open = self.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', String(open));
          toggle.textContent = open ? toggle.dataset.less : toggle.dataset.more;
        });
      }
    });
  }
})();
